import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import styles from "@/styles/article/return-policy.module.scss";
import ArticleTemplate from "@/components/article/ArticleTemplate";
import { usePathname } from "next/navigation";

export default function ReturnPolicy() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "";

  return (
    <>
      <Head>
        <title>Return Policy - BestDeals.co.nz</title>
      </Head>

      <DefaultLayout>
        <div className={`${styles["page-return-policy"]} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <ArticleTemplate articleName={articleName} />
        </div>
      </DefaultLayout>
    </>
  );
}
